import persistStore from "redux-persist/es/persistStore"
import { configureStore } from "@reduxjs/toolkit"
import storage from "redux-persist/lib/storage"
import { persistReducer } from "redux-persist"
import rootReducer from "./rootReducer"

const persistConfig = {
  storage,
  version: 1,
  key: "root",
  whitelist: ["authSlice", "specialistSlice"]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (prev) => prev({ serializableCheck: false })
})

persistStore(store)
export default store